import { render, staticRenderFns } from "./Action_menu.vue?vue&type=template&id=039428c4&scoped=true&lang=pug&"
import script from "./Action_menu.vue?vue&type=script&lang=js&"
export * from "./Action_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039428c4",
  null
  
)

export default component.exports